const ENDPOINTS = {
  CREATE_CHAT: 'createChat'
}

export { ENDPOINTS }
export default ENDPOINTS
